export enum FileError {
  INCORRECT_TYPE = 'INCORRECT_TYPE',
  DUPLICATE = 'DUPLICATE',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
}
